import React from 'react'
import { Grid, IconButton, Tooltip } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import MoveUpIcon from '@mui/icons-material/MoveUp'
import { useHookstate } from '@hookstate/core'
import TransferGroupDispatchDialog from '~/features/Dispatch/components/TransferGroupDispachButton/components/TransferGroupDispatchDialog'

export default function TransferGroupDispachButton({
  canTransferGroupDispatch,
  hasTransferGroupDispach,
}) {
  const open = useHookstate<boolean>(false)
  const { translate } = useLang()

  return (
    <Grid item>
      <Tooltip
        title={translate('Transfer by Dispatch Group')}
        placement="right-start"
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton
            disabled={!hasTransferGroupDispach}
            onClick={() => open.set(true)}
          >
            <MoveUpIcon />
          </IconButton>
        </span>
      </Tooltip>
      {open.get() && <TransferGroupDispatchDialog open={open} />}
    </Grid>
  )
}
